export default {
  'quotations.domain.enums.quotation_status.configuring': 'Configuring',
  'quotations.domain.enums.quotation_status.awaiting_offers': 'Awaiting Offers',
  'quotations.domain.enums.quotation_status.answered': 'Answered',
  'quotations.domain.enums.quotation_status.winners_selected':
    'Winners Selected',
  'quotations.domain.enums.quotation_status.done': 'Done',

  'quotations.domain.enums.item_type.part': 'Part',
  'quotations.domain.enums.item_type.consumable': 'Consumable',

  'quotations.domain.enums.quotation_supplier_status.not_offered':
    'Not Offered',
  'quotations.domain.enums.quotation_supplier_status.offered': 'Offered',

  'quotations.list.button.newQuotation': 'New Quotation',
  'quotations.list.table.title.employeeName': 'Employee',
  'quotations.list.table.title.code': 'Code',
  'quotations.list.table.title.companyName': 'Company',
  'quotations.list.table.title.date': 'Date',
  'quotations.list.table.title.status': 'Status',

  'quotations.form.id': 'ID.',
  'quotations.form.company': 'Company',
  'quotations.form.employee': 'Employee',
  'quotations.form.date': 'Date',
  'quotations.form.status': 'Status',

  'quotations.create': 'Create Quotation',
  'quotations.create.notification.success': 'Success',
  'quotations.create.notification.successDescription': 'Quotation created.',

  'quotations.update': 'Update Quotation',
  'quotations.update.notification.success': 'Success',
  'quotations.update.notification.successDescription': 'Quotation updated.',

  'quotations.remove': 'Remove Quotation',
  'quotations.remove.alert': 'Do you really want to remove the quotation:',
  'quotations.remove.notification.success': 'Success',
  'quotations.remove.notification.successDescription': 'Quotation removed.',

  'quotations.details': 'Quotation Details',

  'quotations.details.report': 'Quotation Report',
  'quotations.details.report.selectReportType': 'Select the report type',
  'quotations.details.report.itemsSuppliers': 'Items/Suppliers',
  'quotations.details.report.suppliersItems': 'Suppliers/Items',
  'quotations.details.report.quotationItems': 'Quotation Items',
  'quotations.details.report.supplierWinners': 'Supplier Winners',

  'quotations.details.report.success.message': 'Success',
  'quotations.details.report.success.messageDescription':
    'Report generated successfully.',

  'quotations.details.report.error.message': 'Error',
  'quotations.details.report.error.messageDescription':
    'Report currently unavailable.',

  'quotations.details.items': 'Items to be Quoted',
  'quotations.details.items.originalCode': 'Original Code',
  'quotations.details.items.manufacturingCode': 'Manufacturer Code',
  'quotations.details.items.name': 'Name',
  'quotations.details.items.manufacturer': 'Manufacturer',
  'quotations.details.items.type': 'Type',
  'quotations.details.items.quantity': 'Qtd.',

  'quotations.details.items.nextError.message': 'Error',
  'quotations.details.items.nextError.description':
    'There should be at least one item',

  'quotations.details.items.create': 'Add Item',

  'quotations.details.items.create.filter': 'Search',
  'quotations.details.items.create.filter.description':
    'Search for items to add',
  'quotations.details.items.create.filter.toBeAdded': 'Items to be added',
  'quotations.details.items.create.filter.search': 'Search',
  'quotations.details.items.create.filter.type': 'Type',

  'quotations.details.items.create.setUp': 'Set up',
  'quotations.details.items.create.setUp.description':
    'Set up the items quantity',

  'quotations.details.items.create.notification.success': 'Success',
  'quotations.details.items.create.notification.successDescription':
    'Quotation items created.',

  'quotations.details.items.update': 'Edit quotation item',
  'quotations.details.items.update.notification.success': 'Success',
  'quotations.details.items.update.notification.successDescription':
    'Quotation item updated.',

  'quotations.details.items.remove': 'Remove Quotation',
  'quotations.details.items.remove.alert':
    'Do you really want to remove the quotation:',
  'quotations.details.items.remove.notification.success': 'Success',
  'quotations.details.items.remove.notification.successDescription':
    'Quotation removed.',

  'quotations.details.suppliers': 'Suppliers',
  'quotations.details.suppliers.name': 'Name',
  'quotations.details.suppliers.email': 'E-Mail',
  'quotations.details.suppliers.type': 'Type',
  'quotations.details.suppliers.status': 'Status',

  'quotations.details.suppliers.create': 'Add Supplier',

  'quotations.details.suppliers.remove': 'Remove quotation supplier',
  'quotations.details.suppliers.remove.alert':
    'Do you really want to remove the quotation supplier:',
  'quotations.details.suppliers.remove.notification.success': 'Success',
  'quotations.details.suppliers.remove.notification.successDescription':
    'Quotation supplier removed.',

  'quotations.details.suppliers.nextError.message': 'Error',
  'quotations.details.suppliers.nextError.description':
    'There should be at least one supplier',

  'quotations.details.offersConfiguration': 'Offers Configuration',
  'quotations.details.offersConfiguration.save': 'Save Configuration',
  'quotations.details.offersConfiguration.save.notification.success': 'Success',
  'quotations.details.offersConfiguration.save.notification.successDescription':
    'Offer configuration updated.',

  'quotations.details.offersConfiguration.nextError.message': 'Error',
  'quotations.details.offersConfiguration.nextError.description':
    'Select a supplier and save the configuration to proceed.',

  'quotations.details.sendQuotationRequest': 'Send Quotation Request',
  'quotations.details.sendQuotationRequest.send': 'Send',
  'quotations.details.sendQuotationRequest.subject': 'Subject',
  'quotations.details.sendQuotationRequest.content': 'Content',
  'quotations.details.sendQuotationRequest.attachment': 'Attachment',
  'quotations.details.sendQuotationRequest.attachmentText':
    'Click or drag a file to this area to upload',
  'quotations.details.sendQuotationRequest.attachmentHint':
    'Add the files that will be sent as attachment to the quotation request.',
  'quotations.details.sendQuotationRequest.notification.success': 'Success',
  'quotations.details.sendQuotationRequest.notification.successDescription':
    'Quotation request sended.',

  'quotations.details.generatePurchase': 'Generate Purchase',
};
